// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { configureSchema } from "@ark/schema/config";
export const configure = configureSchema;
